/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../common/day_of_week';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "resources": {
                "nested": {
                  "BusinessHoursPeriod": {
                    "fields": {
                      "dayOfWeek": {
                        "type": ".squareup.connect.v2.common.DayOfWeek",
                        "id": 1,
                        "rule": "optional"
                      },
                      "startLocalTime": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "endLocalTime": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "SpecialBusinessHoursPeriod": {
                    "fields": {
                      "startDate": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "endDate": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "timePeriods": {
                        "type": ".squareup.connect.v2.resources.TimePeriod",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "daysOfWeek": {
                        "type": ".squareup.connect.v2.common.DayOfWeek",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "reason": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "isClosed": {
                        "type": "bool",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  },
                  "TimePeriod": {
                    "fields": {
                      "startLocalTime": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "endLocalTime": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.resources?.nested?.BusinessHoursPeriod && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.resources?.nested?.SpecialBusinessHoursPeriod && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.resources?.nested?.TimePeriod) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc
 * Represents a period of time during which a business location is open.
 * --
 *
 * SOURCE BusinessHoursPeriod @ squareup/connect/v2/resources/location.proto at 242:1
 */
export const BusinessHoursPeriod = $root.lookupType('squareup.connect.v2.resources.BusinessHoursPeriod');
fixType(BusinessHoursPeriod);
Builder.createAndAttachToType(BusinessHoursPeriod);
/**
 * --
 * @desc
 * Represents a period of time during which a business location is open.
 * --
 *
 * SOURCE SpecialBusinessHoursPeriod @ squareup/connect/v2/resources/location.proto at 283:1
 */
export const SpecialBusinessHoursPeriod = $root.lookupType('squareup.connect.v2.resources.SpecialBusinessHoursPeriod');
fixType(SpecialBusinessHoursPeriod);
Builder.createAndAttachToType(SpecialBusinessHoursPeriod);
/**
 * SOURCE TimePeriod @ squareup/connect/v2/resources/location.proto at 321:1
 */
export const TimePeriod = $root.lookupType('squareup.connect.v2.resources.TimePeriod');
fixType(TimePeriod);
Builder.createAndAttachToType(TimePeriod);